module.exports = __webpack_public_path__ + "static/media/stop words sample data.31431d06.csv";